module.exports = __webpack_public_path__ + "hbomaxar-static/media/flight-attendant.0b2d12d2.mp4";